import FeatureTitle from "./feature-title";

export default FeatureTitle;
